const getURLPattern = (withOptionalProtocols: boolean = false) =>
  new RegExp(
    `^(?:(?:https?)://)${withOptionalProtocols ? "?" : ""}(?:[\\w.-]+(?::[\\w.-]*)?@)?(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\\.)+((?:[a-zA-Z]{2,})|(?:xn--[a-zA-Z0-9]+))|(?:\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3})|localhost)(?::\\d{1,5})?(?:[/?][^\\s]*)?$`,
    "i",
  )

export const urlPatternWithoutHttpPrefix = getURLPattern(true)

export const fullUrlPattern = getURLPattern()
